import React, { Component } from 'react';
import PropTypes from 'prop-types';
import b_ from 'b_';
import { observer } from 'mobx-react';
import { ObservableTextfield } from '../Textfield';
import Button from '../Button';
import InputStore from '../../stores/InputStore';
import FlagStore from '../../stores/FlagStore';
import UrlGuidelines from './UrlGuidelines';
import './UrlPatternInput.css';

const block = b_.lock('UrlPatternInput');

class UrlPatternInput extends Component {
    static propTypes = {
        inputLabel: PropTypes.string,
        guidelinesHeader: PropTypes.string,
        inputStore: InputStore.PropType.isRequired,
        guidelines: FlagStore.PropType.isRequired,
        className: PropTypes.string,
    };
    render() {
        const { inputLabel, guidelinesHeader, inputStore, guidelines, className } = this.props;
        const errorLabel = !inputStore.isEmpty && !inputStore.isTouched && !inputStore.isValid ?
            'This is not a valid URL pattern.' : null;

        return <div className={className}>
            <div className={block('Header')}>
                <ObservableTextfield
                    className={block('Input')}
                    label={inputLabel || 'URL'}
                    store={inputStore}
                    errorLabel={errorLabel}
                    maxLength="2048"
                />

                <Button
                    className={block('ToggleButton', { active: guidelines.isOpen })}
                    iconClassName={block('ToggleButtonIcon', { active: guidelines.isOpen })}
                    icon="help_outline"
                    onClick={guidelines.toggle}
                >
                    URL Patterns
                </Button>
            </div>

            {guidelines.isOpen ? <UrlGuidelines
                onClose={guidelines.close}
                header={guidelinesHeader}
                legacy
            /> : null}
        </div>;
    }
}

export default observer(UrlPatternInput);

